import React from 'react';

import './footer.scss'

const Footer = () => {
    return (
        <div className='footer'>
            <p>&copy; Megasportsworld 2024.</p>
        </div>
    )
}

export default Footer;
